import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { BusinessReportItem } from 'src/modules/motor-credito/serasa/serasa.experian.business.types'

export type IdentificacaoProps = {
    empresa: BusinessReportItem
}

export default function Identificacao({ empresa }: IdentificacaoProps) {
    return (
        <>
            <Divider textAlign="center">Identificação</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Razão Social" value={empresa.identificationReport.companyName || '-'} xs={6} />
                <GridItem label="CNPJ" value={empresa.identificationReport.documentNumber || '-'} xs={6} />
                <GridItem label="Nome Fantasia" value={empresa.identificationReport.companyAlias || '-'} xs={6} />
                <GridItem label="Tipo de Sociedade" value={empresa.identificationReport.partnership || '-'} xs={6} />
                <GridItem label="Opção Tributária" value={empresa.identificationReport.taxOption || '-'} xs={6} />

                <GridItem
                    label="Data de Fundação"
                    value={
                        empresa.identificationReport.companyFoundation
                            ? formatDate(empresa.identificationReport.companyFoundation, 'dd/MM/yyyy')
                            : '-'
                    }
                    xs={6}
                />

                <GridItem
                    label="Quantidade de Filiais"
                    value={empresa.identificationReport.branchOffices || '-'}
                    xs={6}
                />
                <GridItem label="Ramo" value={empresa.identificationReport.economicActivity || '-'} xs={6} />
                <GridItem label="Código CNAE" value={empresa.identificationReport.cnae || '-'} xs={6} />
            </Grid>
        </>
    )
}
